import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const TitleContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	margin: 2rem 0;
`;

export const FormContainer = styled.div`
	display: flex;
	width: 100%;
	overflow-y: auto;

	@media ${Breakpoints.mobile} {
		flex-direction: column;
	}
`;

export const TabContainer = styled.div`
	width: 100%;
	padding-right: var(--padding-2);
	padding-left: var(--padding-2);
	overflow-y: auto;
	height: 100%;
	@media ${Breakpoints.mobile} {
		padding: 0 var(--padding-4) var(--padding-4) var(--padding-4);
	}
`;

export const SummaryContainer = styled.div`
	width: 60%;
	overflow-y: auto;
	background-color: var(--modal-bg-2);
	padding-left: var(--padding-2);
	@media ${Breakpoints.mobile} {
		width: 100%;
		padding-left: 0;
		overflow-y: unset;
	}
`;
